<template>
  <div>
    <template>
      <span v-if="alert.type == alertTypes.MANEUVER">
        If any maneuver occurs
      </span>
      <span v-if="alert.type == alertTypes.CLOSE_APPROACH">
        If any spacecraft
        <strong>
          <TooltipText
            :text="chasersIdsLabel"
            :tooltip="chasersIdsTooltipText"
            :disabled="chasersIdsTooltipText === ''"
          />
        </strong>
        approaches closer than <strong>{{ thresholdLabel }}</strong> in the next
        <strong>{{ alert.nbOfOrbits }}</strong> orbits in the future
      </span>
      <span v-if="alert.type == alertTypes.ORBIT_INSERTION">
        If any spacecraft
        <strong>
          <TooltipText
            :text="chasersIdsLabel"
            :tooltip="chasersIdsTooltipText"
            :disabled="chasersIdsTooltipText === ''"
          />
        </strong>
        inserts in one of the group planes
      </span>
      ,
    </template>
    <template>
      raise a
      <TooltipText
        underlined
        :disabled="
          alert.criticity.customTooltip === '' &&
          alert.criticity.defaultTooltip === ''
        "
        :textStyle="{ color: alert.criticity.color }"
        :text="alert.criticity.name"
        :tooltip="
          alert.criticity.customTooltip || alert.criticity.defaultTooltip
        "
      />
      event.
    </template>
  </div>
</template>

<script>
import TooltipText from './TooltipText'

export default {
  name: 'ScreeningAlertText',

  props: {
    alert: {
      type: Object
    }
  },

  components: {
    TooltipText
  },

  data() {
    return {}
  },

  computed: {
    alertTypes() {
      let alertTypes = {
        MANEUVER: 'MANEUVER',
        CLOSE_APPROACH: 'CLOSE_APPROACH',
        ORBIT_INSERTION: 'ORBIT_INSERTION'
      }
      return Object.freeze(alertTypes)
    },

    chasersIdsLabel() {
      const ids = this.alert.potentialChaserIds
      if (ids != null) {
        if (ids.length < 4) {
          return 'in [' + ids.join(', ') + '] '
        } else {
          return 'in [' + ids.slice(0, 3).join(', ') + ', ...] '
        }
      } else {
        return ''
      }
    },

    chasersIdsTooltipText() {
      const ids = this.alert.potentialChaserIds
      if (ids != null && ids.length >= 4) {
        return '[' + ids.join(', ') + '] '
      } else {
        return ''
      }
    },

    thresholdLabel() {
      return `${(this.alert.threshold / 1000).toFixed(2)} km`
    }
  }
}
</script>
